import { render, staticRenderFns } from "./ManageFarmer.vue?vue&type=template&id=57d73f1e"
import script from "./ManageFarmer.vue?vue&type=script&lang=js"
export * from "./ManageFarmer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports